<template>
  <!-- 侧边栏 -->
  <div class="aside">
    <el-row class="tac">
      <el-col>
        <el-menu default-active="1" text-color="#979150" :unique-opened="true">
          <el-submenu :index="k + ''" v-for="(item, k) in menuList" :key="k">
            <template slot="title">
              <i class="iconfont icon-iconleijihuiyuan"></i>
              <span>{{ item.menuName }}</span>
            </template>
            <el-menu-item :index="childrenMenu.id" @click="goToInForMations(childrenMenu)" v-for="(childrenMenu, i) in item.children" :key="i + ''">
              {{ childrenMenu.menuName }}
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUserRights } from "@/api/login.js";
export default {
  data() {
    return {
      menuList: [],
    };
  },
  created() {
    getUserRights({}).then((res) => {
      this.menuList = res.data[0].children;
      localStorage.setItem("name", res.empName + "(" + res.empCode + ")");
      console.log(res.empCode, res.empName, this.menuList);
    });
  },
  methods: {
    // 跳转到会员信息管理页面
    goToInForMations(menu) {
      let data = menu.children;
      localStorage.setItem(menu.menuUrl, JSON.stringify(data));
      this.$router.push(menu.menuUrl);
    },
    // 跳转会员合并页面
    goToMerge() {
      this.$router.push("/Merge");
    },
    goToMembersTurn() {
      this.$router.push("/MembersTurn");
    },
    // 跳转会员转店页面

    goToManagement() {
      this.$router.push("/Management");
    },
    //跳转到改衣单页面
    goToAlterations() {
      this.$router.push("/Alterations");
    },
    //跳转到门店管理
    goToStores() {
      this.$router.push("/Stores");
    },
    goToProducts() {
      this.$router.push("/Products");
    },
    //跳转到冻结卡页面
    goToFreezeLevel() {
      this.$router.push("/FreezeLevel");
    },
    //跳转到顾客维护记录页面
    goToMaintenance() {
      this.$router.push("/Maintenance");
    },
    goTOAdjustment() {
      this.$router.push("/Adjustment");
    },
    // 跳转到会员级别调整
    goToManagingHolds() {
      this.$router.push("/ManagingHolds");
    },
    // 跳转到自定义选项页面
    goToCustom() {
      this.$router.push("/Custom");
    },
    // 模板消息设置
    goToMessage() {
      this.$router.push("/Templatetion");
    },
    // 跳转到原因定义列表
    goToDefine() {
      this.$router.push("/Define");
    },
    goToIntegrationRule() {
      this.$router.push("/IntegrationRule");
    },
    goToCardRule() {
      this.$router.push("/CardRule");
    },
    goToVoucherSet() {
      this.$router.push("/VoucherSet");
    },
    goToEquities() {
      this.$router.push("/Equities");
    },
    goToFriends() {
      this.$router.push("/Friends");
    },
    goToGradeRule() {
      this.$router.push("/GradeRule");
    },
    goToRequisition() {
      this.$router.push("/Requisition");
    },
    goToAdministration() {
      this.$router.push("/Administration");
    },
    goToInformation() {
      this.$router.push("/Information");
    },
    goToQualification() {
      this.$router.push("/Qualification");
    },
    goToShare() {
      this.$router.push("/Share");
    },
    goToProduct() {
      this.$router.push("/Product");
    },
    goToCash() {
      this.$router.push("/Cash");
    },
    goToGiadaFriendsCash() {
      this.$router.push("/GiadaFriendsCash");
    },
    goToDiscountCoupon() {
      this.$router.push("/DiscountCoupon");
    },
    goToMerchandiseBond() {
      this.$router.push("/MerchandiseBond");
    },
    goToAbnormal() {
      this.$router.push("/Abnormal");
    },
    goToCoupon() {
      this.$router.push("/Coupon");
    },
    goToIssuedStamps() {
      this.$router.push("/IssuedStamps");
    },
    goToMasterData() {
      this.$router.push("/MasterData");
    },
    goToCommodity() {
      this.$router.push("/Commodity");
    },
    goToConversion() {
      this.$router.push("/Conversion");
    },
    goToManager() {
      this.$router.push("/Manager");
    },
    goToConditionalGrouping() {
      this.$router.push("/ConditionalGrouping");
    },
    goToManagementActivities() {
      this.$router.push("/ManagementActivities");
    },
    goToManualGroup() {
      this.$router.push("/ManualGroup");
    },
    goToUserManagement() {
      this.$router.push("/UserManagement");
    },
    goToRoleDefinition() {
      this.$router.push("/RoleDefinition");
    },
    goToDataDefinition() {
      this.$router.push("/DataDefinition");
    },
    goToPermissionQuery() {
      this.$router.push("/PermissionQuery");
    },
    goToRetrievePassword() {
      this.$router.push("/RetrievePassword");
    },
    // 跳转到公司品牌切换
    goToBrandSwitch() {
      this.$router.push("/BrandSwitching");
    },
  },
};
</script>

<style lang="scss" scoped>
.aside {
  width: 100%;
  height: 100%;
  background-color: #eae6be;
}
.el-menu {
  border-right: none;
  background-color: #eae6be;
}

.el-menu-item {
  background-color: #f5f3e0;
}

.iconfont {
  color: #979150;
  margin-right: 5px;
}
/* 改变elementui 侧边栏移入颜色 */
::v-deep {
  .el-icon-arrow-down:before {
    font-size: 16px;
    font-weight: 700;
    color: #979150;
  }
  // 侧边栏字体颜色
  .el-submenu__title {
    padding-left: 40px !important;
    font-size: 16px;
    color: #979150;
  }
  .el-menu-item:hover {
    background: #b9b47c !important;
    color: #fff !important;
  }
  .el-submenu__title:hover {
    background: #b9b47c !important;
    color: #fff !important;
  }
  .el-menu-item.is-active {
    background: #b9b47c !important;
    color: #fff !important;
  }
  .el-submenu__title.is-active {
    background: #b9b47c !important;
    color: #fff !important;
  }
}
</style>
